const crypto_js=require('crypto-js');

const CryptoJSAES = crypto_js.AES; 
const encutf8=crypto_js.enc.Utf8;

const miyao = 'PmsEK1XZdmsILoqe';

/* 储存localStorage */
 const setStore = (name, value) => {
  if (!name) {
    return false;
  }
  if (typeof value !== 'string') {
     value = JSON.stringify(value);
  }
  // window.localStorage.setItem(name, value);
  //加密
  let string_value = CryptoJSAES.encrypt(value, miyao);
  window.localStorage.setItem(name, string_value);
}
const setTitleStore = (name, value) => {
  if (!name) {
    return false;
  }
  if (typeof value !== 'string') {
     value = JSON.stringify(value);
  }
  // window.localStorage.setItem(name, value);
  //加密
  window.localStorage.setItem(name, value);
}

/**
 * 设置cookie
 * @param {[type]} key   [键名]
 * @param {[type]} value [键值]
 * @param {[type]} days  [保存的时间（天）]
 */
const setCookie = (key, value, days) => {
    if (!value) {
        localStorage.removeItem(key)
    } else {
        var Days = days || 7; // 默认保留7天
        var exp = new Date();
        localStorage[key] = JSON.stringify({
            value,
            expires: exp.getTime() + Days * 24 * 60 * 60 * 1000
        })
    }
}
/**
 * 设置cookie
 * @param {[type]} key   [键名]
 */
const getCookie = (name) => {
    try {
        let o = JSON.parse(localStorage[name])
        if (!o || o.expires < Date.now()) {
            return null
        } else {
        return o.value
        }
    } catch (e) {
            // 兼容其他localstorage 
            console.log(e)
            return localStorage[name]
    } finally {

    }
}

/* 获取指定的localstorage */
 const getStore = (name) => {
  if (!name) return false;
  try {
    if (window.localStorage.getItem(name) && window.localStorage.getItem(name).length > 1) {
      let return_string = CryptoJSAES.decrypt(window.localStorage.getItem(name), miyao);
      return_string=return_string.toString(encutf8);
      try {
        return JSON.parse(return_string);
      } catch (error) {
        return return_string;
      }
      //解密
    } 
  } catch (error) {
    console.log(error);
  }
  return false;
}
/* 获取指定的localstorage */
const getTitleStore = (name) => {
  if (!name) return false;
  try {
    if (window.localStorage.getItem(name) && window.localStorage.getItem(name).length > 1) {
      let return_string = window.localStorage.getItem(name);
      return_string=return_string.toString(encutf8);
      try {
        return JSON.parse(return_string);
      } catch (error) {
        return return_string;
      }
      //解密
    } 
  } catch (error) {
    console.log(error);
  }
  return false;
}

/* 删除指定的localStorage */
 const removeStore = (name) => {
  if (!name || !window.localStorage.getItem(name)) return false;
  window.localStorage.removeItem(name);
}

export default {
    setStore,
    setTitleStore,
    getStore,
    getTitleStore,
    removeStore
}



// WEBPACK FOOTER //
// ./src/libs/js/localStorage.js